import type { AxiosHeaderValue, AxiosHeaders, AxiosRequestHeaders } from 'axios';

type HeaderSetter = { set: (name: string, value: string) => void };
type PlainHeaders = Record<string, AxiosHeaderValue | undefined>;
type HeaderInput = AxiosHeaders | AxiosRequestHeaders | PlainHeaders | undefined;

const hasHeaderSetter = (headers: unknown): boolean => {
  return Boolean(
    headers &&
    typeof headers === 'object' &&
    'set' in headers &&
    typeof (headers as HeaderSetter).set === 'function'
  );
};

export const attachCsrfHeader = (
  headers: HeaderInput,
  headerName: string,
  token: string
): AxiosRequestHeaders => {
  if (hasHeaderSetter(headers)) {
    (headers as HeaderSetter).set(headerName, token);
    return headers as unknown as AxiosRequestHeaders;
  }

  const plainHeaders = (headers || {}) as Record<string, AxiosHeaderValue | undefined>;

  return {
    ...plainHeaders,
    [headerName]: token,
  } as AxiosRequestHeaders;
};
